import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { formatClock, formatDay, punchDisplayValue, type AttendancePunch } from '@/pages/attendance/data'

function punchDateTime(value: string | null | undefined, timeZone?: string | null) {
  if (!value) return '—'
  const day = formatDay(value, timeZone)
  const clock = formatClock(value, timeZone)
  if (day === '—' && clock === '—') return '—'
  if (day === '—') return clock
  if (clock === '—') return day
  return `${day}, ${clock}`
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="grid grid-cols-[7.5rem_1fr] gap-3 text-sm">
      <dt className="text-slate-500">{label}</dt>
      <dd className="font-medium text-slate-900">{value || '—'}</dd>
    </div>
  )
}

export function PunchInfoDialog({
  open,
  onOpenChange,
  punch,
  employeeName,
  timeZone,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  punch: AttendancePunch | null
  employeeName: string
  /** Tenant IANA timezone; when given, punch times show in that zone. Omitted keeps the existing output. */
  timeZone?: string | null
}) {
  const checkedOut = Boolean(punch?.check_out || punch?.check_out_local)
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Punch info</DialogTitle>
          <DialogDescription>{employeeName}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <section className="space-y-2">
            <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-500">Check in</h3>
            <dl className="space-y-1.5">
              <InfoRow label="Date and time" value={punchDateTime(punchDisplayValue(punch?.check_in, punch?.check_in_local, timeZone), timeZone)} />
              <InfoRow label="Recorded by" value={punch?.created_by_name || '—'} />
            </dl>
          </section>
          <section className="space-y-2">
            <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-500">Check out</h3>
            <dl className="space-y-1.5">
              <InfoRow label="Date and time" value={checkedOut ? punchDateTime(punchDisplayValue(punch?.check_out, punch?.check_out_local, timeZone), timeZone) : '—'} />
              <InfoRow label="Recorded by" value={checkedOut ? (punch?.updated_by_name || punch?.created_by_name || '—') : '—'} />
            </dl>
          </section>
          <section className="space-y-2">
            <h3 className="text-xs font-semibold uppercase tracking-wide text-slate-500">Device</h3>
            <dl className="space-y-1.5">
              <InfoRow label="Name" value={punch?.attendance_device_name || '—'} />
              <InfoRow label="Serial number" value={punch?.attendance_device_sn || '—'} />
            </dl>
          </section>
        </div>
      </DialogContent>
    </Dialog>
  )
}
